import React from "react"

export function IconBag() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 64 64" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.5073 17.1492H43.4863C42.6989 11.8988 37.9947 8 32.4468 8C26.899 8 22.1947 11.8988 21.4073 17.1492H14.3863C12.5161 17.1492 11 18.5987 11 20.3868V52.7624C11 54.5505 12.5161 56 14.3863 56H50.5073C52.3775 56 53.8936 54.5505 53.8936 52.7624V20.3868C53.8936 18.5987 52.3775 17.1492 50.5073 17.1492ZM32.4468 11.2137C36.042 11.4396 39.0898 13.8245 40.0322 17.1492H24.8614C25.8038 13.8245 28.8516 11.4396 32.4468 11.2137V11.2137ZM50.5073 52.7624H14.3863V20.3868H21.159V23.6243C21.159 24.5184 21.9171 25.2431 22.8522 25.2431C23.7873 25.2431 24.5454 24.5184 24.5454 23.6243V20.3868H40.3483V23.6243C40.3483 24.5184 41.1063 25.2431 42.0414 25.2431C42.9765 25.2431 43.7346 24.5184 43.7346 23.6243V20.3868H50.5073V52.7624Z"
        fill="black"
      />
    </svg>
  )
}
